const lbaGridItem = angular.module('app.lbaGridItem', []);

lbaGridItem.controller('lbaGridItemCtrl', require('./lbaGridItemCtrl'));
lbaGridItem.directive('lbaGridItem', require('./lbaGridItemDir'));

export default lbaGridItem;



// WEBPACK FOOTER //
// ./src/components/lbaGridItem/index.js